<template>
  <div class="container">
    <app-header title="优惠券中心"></app-header>
    <!-- 分类 -->
    <div class="tabs">
      <div class="tab">
        <div class="item" v-for="(item,index) in tabList" :key="index">
          <div @click="handleTag(index)" :class="activeTag==index ? 'active':''">{{item}}</div>
        </div>
      </div>
    </div>
    <!-- 全部优惠券 -->
    <div v-if="serial==0">
        <div v-for="(item,index) in counponList" :key="index" @click="_saveShopCoupon(item.id,item.type)" class="rechargeimg" :style="notUse"  style="height: 115px; width: 95%;margin-left: 2%">
          <div class="name">{{item.title}}</div>
          <div class="price">￥{{item.money}}</div>
          <div class="date" v-if="item.couponType == 0">有效期：{{item.endTime}}</div>
          <div class="date" v-else>有效期：{{item.effective}}天</div>
        </div>
        <div style="height: 50px;"></div>
      <empty  v-if="counponList.length == 0"/>
    </div>

    <!-- 电子元器件 -->
    <div v-if="serial==1">
      <div v-for="(item,index) in counponList" :key="index" @click="_saveShopCoupon(item.id,item.type)" class="rechargeimg" :style="notUse" style="height: 115px; width: 95%;margin-left: 2%">
        <div class="name">{{item.title}}</div>
        <div class="price">￥{{item.money}}</div>
        <div class="date" v-if="item.couponType == 0">有效期：{{item.endTime}}</div>
        <div class="date" v-else>有效期：{{item.effective}}天</div>
      </div>
      <div style="height: 50px;"></div>
      <empty  v-if="counponList.length == 0"/>
    </div>

    <!-- 电子产品 -->
    <div v-if="serial==2">
      <div v-for="(item,index) in counponList" :key="index" @click="_saveShopCoupon(item.id,item.type)" class="rechargeimg" :style="notUse" style="height: 115px; width: 95%;margin-left: 2%">
        <div class="name">{{item.title}}</div>
        <div class="price">￥{{item.money}}</div>
        <div class="date" v-if="item.couponType == 0">有效期：{{item.endTime}}</div>
        <div class="date" v-else>有效期：{{item.effective}}天</div>
      </div>
      <div style="height: 50px;"></div>
      <empty  v-if="counponList.length == 0"/>
    </div>
    <!-- 其他 -->
    <div v-if="serial==3">
      <div v-for="(item,index) in counponList" :key="index" @click="_saveShopCoupon(item.id,item.type)" class="rechargeimg" :style="notUse" style="height: 115px; width: 95%;margin-left: 2%">
        <div class="name">{{item.title}}</div>
        <div class="price">￥{{item.money}}</div>
        <div class="date" v-if="item.couponType == 0">有效期：{{item.endTime}}</div>
        <div class="date" v-else>有效期：{{item.effective}}天</div>
      </div>
      <div style="height: 50px;"></div>
      <empty  v-if="counponList.length == 0"/>
    </div>
  </div>
</template>

<script>
import { getSysCounponIsGet, saveShopCoupon } from '@/api/coupon/index.js'
export default {
  name: 'Core',
  data() {
    return {
      notUse: {
        backgroundImage: 'url(' + require('@/assets/not-use.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100% 100%',
        mozBackgroundSize: '100% 100%'
      },
      rechargeimg: {
        backgroundImage: 'url(' + require('@/assets/use.png') + ')',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'center',
        backgroundSize: '100% 100%',
        mozBackgroundSize: '100% 100%'
      },
      active: 0,
      activeTag: 0,
      serial: '0',
      tabList: ['全部', '电子元器件产品', '电子产品', '其他产品'],
      counponList: []
    }
  },
  created() {
    this._getSysCounponIsGet()
  },
  methods: {
    // 优惠劵列表
    _getSysCounponIsGet() {
      var user = localStorage.getItem('userInfo')
      user = JSON.parse(user)
      if (!user){
        this.$router.push({
          path: '/login'
        })
      }
      const params = {
        type: this.activeTag,
        uid: user.id
      }
      getSysCounponIsGet(params).then((res) => {
        this.counponList = [];
        if (res.success) {
          // res.data.forEach((item)=>{
          //   if (item.isGet==0){
          //     this.counponList.push(item)
          //   }
          // })
          this.counponList = res.data
        }
      })
    },
    // 优惠劵领取
    _saveShopCoupon(cid,type) {
      let user = JSON.parse(localStorage.getItem("userInfo"))
      if (!user){
        this.$router.push({
          path: '/login'
        })
      }
      const params = {
        uid: user.id,
        cid: cid,
        type: type
      }
      saveShopCoupon(params).then((res) => {
        if (res.success) {
          this.$toast.success('领取成功')
          this._getSysCounponIsGet()
        }
      })
    },
    handleTag(index) {
      this.activeTag = index
      if (index === 0) {
        this.serial = 0
      } else if (index === 1) {
        this.serial = 1
      } else if (index === 2) {
        this.serial = 2
      } else {
        this.serial = 3
      }
      this._getSysCounponIsGet()
    },
    myCoupon() {
      this.$router.push('/myCoupon')
    }
  }
}
</script>

<style lang="less" scoped>
  .container{
    .tabs{
      display: flex;
      flex-direction: row;
      align-items: center;
      height:44px;
      padding: 0 12px;
      .tab{
        display: flex;
        flex-direction: row;
        flex: 1;
        justify-content: space-between;
        .item{
          font-size:14px;
          font-weight:500;
          height:22px;
          font-family:PingFang SC;
          line-height:22px;
          color:rgba(51,51,51,1);
          margin-right: 14px;
          .active{
            font-size:16px;
            font-weight:bold;
            color: #FE003B;
            border-bottom: 3px solid #FE003B;
          }
        }
      }
    }
    .name{
      font-size:18px;
      font-family:PingFang SC;
      font-weight:bold;
      line-height:25px;
      color:rgba(51,51,51,1);
      opacity:1;
      padding-top: 27px;
      text-align: center;
    }
    .price{
      font-size:18px;
      font-family:PingFang SC;
      font-weight:bold;
      line-height:25px;
      color:rgba(255,0,0,1);
      text-align: center;
      opacity:1;
    }
    .date{
      margin-top: 3px;
      font-size:12px;
      font-family:PingFang SC;
      font-weight:400;
      line-height:17px;
      color:rgba(204,204,204,1);
      opacity:1;
      margin-left: 15px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/mine/coupon/core.vue